import React, { useContext} from "react";
import GlobalContext from "../../../isp._comun/contexto/GlobalContext";

// import { Menubar } from "primereact/menubar";
// import { Image } from "primereact/image";
// import { Menu } from "primereact/menu";

import BotonMenu from "./BotonMenu";
import MenuItemsOrdenes from './MenuItemsOrdenes'
import MenuItemsClientes from './MenuItemsClientes'
import MenuItemsCatalogo from "./MenuItemsCatalogo";
import MenuItemsServicios from "./MenuItemsServicios";
import MenuItemsRRHH from "./MenuItemsRRHH";
import MenuItemsSeguridad from "./MenuItemsSeguridad";
import MenuItemsAdministracion from "./MenuItemsAdministracion";

// import * as Evento from "../../../_comun/Eventos";
import PanelInteractivoDeCerrarSesion from "../PanelInteractivoDeCerrarSesion";

const BarraMenu = () => {
    const {
        // usuario,
        // cerrarSesion,
        // abrirVentanaClienteAFacturar,
        // notificarEventoDeSeguridad,
        dispatchPrincipal,
        // banderaCerrandoSesion,
        // abrirVentanaCrearFia,
        // abrirVentanaQueryFias,
        // cargarPantallaLogin
    } = useContext(GlobalContext);


    return (
        <div className="flex p-menubar mt-4 mx-4 px-0 py-0.5 justify-between">

            <div className="flex">
            
                <BotonMenu label="Ordenes" icono="pi pi-copy" items={MenuItemsOrdenes(dispatchPrincipal)}></BotonMenu>
                <BotonMenu label="Clientes" icono="pi pi-dollar" items={MenuItemsClientes(dispatchPrincipal)}></BotonMenu>
                <BotonMenu label="Catalogo" icono="pi pi-dollar" items={MenuItemsCatalogo(dispatchPrincipal)}></BotonMenu>
                <BotonMenu label="Servicios" icono="pi pi-server" items={MenuItemsServicios(dispatchPrincipal)}></BotonMenu>  
                <BotonMenu label="Recursos Humanos" icono="pi pi-users" items={MenuItemsRRHH(dispatchPrincipal)}></BotonMenu>  
                <BotonMenu label="Seguridad" icono="pi pi-lock" items={MenuItemsSeguridad(dispatchPrincipal)}></BotonMenu>  
                <BotonMenu label="Administración" icono="pi pi-chart-line" items={MenuItemsAdministracion(dispatchPrincipal)}></BotonMenu>  
                             
            </div>

            <div id="usuarioLogueado" className="flex items-center rounded ml-1 mr-3">
                <i
                    className="pi pi-fw pi-user mr-2"
                    style={{ fontSize: "3em" }}
                ></i>
                <div className="flex flex-col items-center">
                    <PanelInteractivoDeCerrarSesion />
                </div>
            </div>  
        </div>
        
        
    );
};
export default BarraMenu;
